import { render, staticRenderFns } from "./InspectionDetailContent.vue?vue&type=template&id=e08e05d8&scoped=true&"
import script from "./InspectionDetailContent.vue?vue&type=script&lang=ts&"
export * from "./InspectionDetailContent.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionDetailContent.vue?vue&type=style&index=0&id=e08e05d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08e05d8",
  null
  
)

export default component.exports